import { useState } from "react";
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCnz4kCySVwFZks9BH06peJuEjo1UzKdYw",
  authDomain: "siparisimiz-54d8f.firebaseapp.com",
  projectId: "siparisimiz-54d8f",
  storageBucket: "siparisimiz-54d8f.firebasestorage.app",
  messagingSenderId: "1021220632139",
  appId: "1:1021220632139:web:f50c48d42f385cda51ffce"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

function Logo({ size = 120, showText = true }) {
  return (
    <svg
      width={size}
      height={showText ? size * 1.3 : size}
      viewBox={showText ? "0 0 200 260" : "0 0 200 200"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="100" cy="100" r="90" fill="#FF6B00"/>
      <circle cx="100" cy="100" r="78" fill="white"/>
      <circle cx="100" cy="100" r="72" fill="#1A2744"/>
      <g transform="rotate(-35 100 95)">
        <rect x="88" y="40" width="4" height="26" rx="2" fill="#FF6B00"/>
        <rect x="94" y="40" width="4" height="26" rx="2" fill="#FF6B00"/>
        <rect x="100" y="40" width="4" height="26" rx="2" fill="#FF6B00"/>
        <rect x="106" y="40" width="4" height="26" rx="2" fill="#FF6B00"/>
        <rect x="88" y="60" width="22" height="7" rx="3" fill="#FF6B00"/>
        <rect x="97" y="67" width="4" height="45" rx="2" fill="#FF6B00"/>
      </g>
      <g transform="rotate(35 100 95)">
        <path d="M96 40 L108 40 Q116 55 110 70 L96 70 Z" fill="#FF6B00"/>
        <rect x="100" y="70" width="6" height="42" rx="3" fill="#FF6B00"/>
      </g>
      <circle cx="100" cy="142" r="4" fill="white"/>
      <path d="M90 134 Q100 128 110 134" stroke="white" strokeWidth="4" fill="none" strokeLinecap="round"/>
      <path d="M80 124 Q100 114 120 124" stroke="white" strokeWidth="4" fill="none" strokeLinecap="round" opacity="0.7"/>
      {showText && (
        <text x="100" y="235" textAnchor="middle"
          fontFamily="Nunito, sans-serif" fontWeight="900"
          fontSize="38" fill="#FF6B00">
          Siparişimiz
        </text>
      )}
    </svg>
  );
}

const ozellikler = [
  { icon: "📱", baslik: "QR Menü & Sipariş", aciklama: "Müşteri QR okutur, sipariş verir. Garson onaylar, mutfak hazırlar." },
  { icon: "🔔", baslik: "Garson Çağrı Sistemi", aciklama: "Masa butonu veya QR ile anlık çağrı. Garson telefonuna düşer." },
  { icon: "👨‍🍳", baslik: "Mutfak Ekranı (KDS)", aciklama: "Kağıt fiş yok. Siparişler sırayla mutfak ekranına düşer." },
  { icon: "📦", baslik: "Otomatik Stok Takibi", aciklama: "Sipariş verilince stok otomatik düşer. Kritik seviyede uyarı." },
  { icon: "💳", baslik: "POS Entegrasyonu", aciklama: "Hesabı böl, POS'a gönder. Sadece kartı okutmak kalır." },
  { icon: "📊", baslik: "Patron Paneli", aciklama: "Nerede olursan ol ciroyu, siparişleri ve stoku anlık gör." },
];

const farklar = [
  { icon: "⚡", baslik: "30 Dakikada Kurulum", aciklama: "Karmaşık kurulum yok. 30 dakikada sisteminiz hazır." },
  { icon: "📶", baslik: "İnternet Kesilse de Çalışır", aciklama: "Bulut + lokal hibrit. Bağlantı kopsa bile hizmet durmuyor." },
  { icon: "🎁", baslik: "Hepsi Tek Pakette", aciklama: "Web sitesi, QR menü, stok, garson — hepsi bir fiyata." },
  { icon: "💬", baslik: "7/24 Canlı Destek", aciklama: "Yoğun serviste sorun yaşamazsınız. Her an yanınızdayız." },
];

export default function App() {
  const [email, setEmail] = useState("");
  const [oneri, setOneri] = useState("");
  const [emailDurum, setEmailDurum] = useState("");
  const [oneriDurum, setOneriDurum] = useState("");
  const [emailHata, setEmailHata] = useState("");

  const handleEmail = async () => {
    setEmailHata("");
    if (!email) { setEmailHata("Email adresinizi girin."); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setEmailHata("Geçerli bir email girin."); return; }
    setEmailDurum("yukleniyor");
    try {
      await addDoc(collection(db, "erken_erisim"), {
        email, tarih: serverTimestamp(), kaynak: window.location.hostname
      });
      setEmailDurum("basarili");
      setEmail("");
    } catch(e) {
      console.error("Email hata:", e);
      setEmailDurum("hata");
    }
  };

  const handleOneri = async () => {
    if (!oneri.trim()) return;
    setOneriDurum("yukleniyor");
    try {
      await addDoc(collection(db, "oneriler"), {
        oneri: oneri.trim(),
        tarih: serverTimestamp(),
        kaynak: window.location.hostname
      });
      setOneriDurum("basarili");
      setOneri("");
    } catch(e) {
      console.error("Öneri hata:", e);
      setOneriDurum("hata");
    }
  };

  return (
    <div style={{ minHeight:"100vh", background:"#F7F8FC", fontFamily:"'Nunito', sans-serif", color:"#1A2744" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800;900&display=swap');
        * { box-sizing:border-box; margin:0; padding:0; }

        @keyframes fadeUp { from{opacity:0;transform:translateY(24px);} to{opacity:1;transform:translateY(0);} }
        @keyframes pulse { 0%,100%{opacity:1;} 50%{opacity:0.3;} }
        @keyframes float { 0%,100%{transform:translateY(0);} 50%{transform:translateY(-10px);} }
        @keyframes shimmer { 0%{background-position:-200% center;} 100%{background-position:200% center;} }

        .fade-1{animation:fadeUp .7s ease .1s both;}
        .fade-2{animation:fadeUp .7s ease .25s both;}
        .fade-3{animation:fadeUp .7s ease .4s both;}
        .fade-4{animation:fadeUp .7s ease .55s both;}
        .fade-5{animation:fadeUp .7s ease .7s both;}
        .fade-6{animation:fadeUp .7s ease .85s both;}
        .fade-7{animation:fadeUp .7s ease 1s both;}
        .fade-8{animation:fadeUp .7s ease 1.15s both;}

        .logo-float{animation:float 4s ease-in-out infinite;}

        .shimmer-text {
          background:linear-gradient(90deg,#FF6B00 0%,#ff9a4d 40%,#FF6B00 60%,#ff9a4d 100%);
          background-size:200% auto;
          -webkit-background-clip:text; -webkit-text-fill-color:transparent;
          animation:shimmer 3s linear infinite;
        }

        .top-banner {
          background:linear-gradient(90deg,#1A2744 0%,#243560 100%);
          padding:11px 24px; text-align:center;
          font-size:13px; font-weight:700; color:rgba(255,255,255,0.7); letter-spacing:.04em;
        }
        .top-banner span{color:#FF6B00;}

        .hero {
          background:linear-gradient(160deg,#1A2744 0%,#1e3060 100%);
          padding:72px 24px 100px; text-align:center; position:relative; overflow:hidden;
        }
        .hero::before {
          content:''; position:absolute; top:-150px; left:50%; transform:translateX(-50%);
          width:700px; height:500px;
          background:radial-gradient(ellipse,rgba(255,107,0,0.18) 0%,transparent 65%);
          pointer-events:none;
        }

        .hero-badge {
          display:inline-flex; align-items:center; gap:8px;
          background:rgba(255,107,0,0.1); border:1.5px solid rgba(255,107,0,0.25);
          border-radius:100px; padding:8px 20px;
          font-size:13px; font-weight:700; color:#FF6B00;
        }
        .pulse-dot{width:8px;height:8px;border-radius:50%;background:#FF6B00;animation:pulse 1.8s infinite;}

        .card {
          background:white; border-radius:20px;
          box-shadow:0 4px 24px rgba(26,39,68,0.07);
          border:1.5px solid rgba(26,39,68,0.05);
          transition:all .25s;
        }
        .card-hover:hover{transform:translateY(-4px);box-shadow:0 12px 40px rgba(255,107,0,0.1);border-color:rgba(255,107,0,0.15);}

        .value-card {
          background:white; border-radius:16px; padding:22px;
          border-left:4px solid #FF6B00;
          box-shadow:0 2px 16px rgba(26,39,68,0.06);
          transition:all .25s;
        }
        .value-card:hover{transform:translateY(-3px);box-shadow:0 8px 32px rgba(255,107,0,0.1);}

        .feature-icon {
          width:52px; height:52px; border-radius:14px;
          background:linear-gradient(135deg,rgba(255,107,0,0.1),rgba(26,39,68,0.04));
          display:flex; align-items:center; justify-content:center;
          font-size:24px; margin-bottom:14px;
        }

        .email-input {
          flex:1; background:#F7F8FC; border:1.5px solid #E2E8F0;
          border-radius:12px; padding:15px 18px; font-size:15px;
          font-family:'Nunito',sans-serif; color:#1A2744; outline:none;
          transition:all .2s; width:100%;
        }
        .email-input:focus{border-color:#FF6B00;background:white;box-shadow:0 0 0 3px rgba(255,107,0,0.08);}
        .email-input::placeholder{color:#A0AEC0;}

        .textarea-input {
          width:100%; background:#F7F8FC; border:1.5px solid #E2E8F0;
          border-radius:12px; padding:15px 18px; font-size:15px;
          font-family:'Nunito',sans-serif; color:#1A2744; outline:none;
          transition:all .2s; resize:vertical; min-height:110px; line-height:1.6;
        }
        .textarea-input:focus{border-color:#FF6B00;background:white;box-shadow:0 0 0 3px rgba(255,107,0,0.08);}
        .textarea-input::placeholder{color:#A0AEC0;}

        .btn {
          background:#FF6B00; color:white; border:none; border-radius:12px;
          padding:15px 28px; font-size:15px; font-weight:800;
          font-family:'Nunito',sans-serif; cursor:pointer; white-space:nowrap;
          transition:all .2s; box-shadow:0 4px 16px rgba(255,107,0,0.3);
        }
        .btn:hover{background:#e55f00;transform:translateY(-1px);box-shadow:0 6px 24px rgba(255,107,0,0.4);}
        .btn:disabled{opacity:.6;cursor:not-allowed;transform:none;}

        .btn-outline {
          background:transparent; color:#FF6B00; border:2px solid #FF6B00;
          border-radius:12px; padding:13px 28px; font-size:15px; font-weight:800;
          font-family:'Nunito',sans-serif; cursor:pointer; transition:all .2s;
          text-decoration:none; display:inline-block;
        }
        .btn-outline:hover{background:#FF6B00;color:white;}

        .success{background:#F0FFF4;border:1.5px solid #9AE6B4;border-radius:12px;padding:14px 20px;color:#276749;font-weight:700;text-align:center;}
        .error{background:#FFF5F5;border:1.5px solid #FC8181;border-radius:12px;padding:14px 20px;color:#C53030;font-weight:700;text-align:center;}

        .section-label{font-size:12px;text-transform:uppercase;letter-spacing:.15em;color:#A0AEC0;font-weight:700;text-align:center;margin-bottom:12px;}

        @media(max-width:600px){
          .form-row{flex-direction:column!important;}
          .features-grid{grid-template-columns:1fr!important;}
          .value-grid{grid-template-columns:1fr 1fr!important;}
          .compare-grid{grid-template-columns:1fr!important;}
          .hero-btns{flex-direction:column!important;align-items:stretch!important;}
        }
      `}</style>

      {/* Üst banner */}
      <div className="top-banner">
        🚀 Erken erişime kaydolun — <span>ilk 100 işletmeye özel fiyat garantisi!</span>
      </div>

      {/* Hero */}
      <div className="hero">
        <div style={{ maxWidth:680, margin:"0 auto", position:"relative", zIndex:1 }}>
          <div className="fade-1" style={{ display:"flex", justifyContent:"center", marginBottom:28 }}>
            <div className="logo-float"><Logo size={110} showText={true}/></div>
          </div>
          <div className="fade-1" style={{ display:"flex", justifyContent:"center", marginBottom:24 }}>
            <div className="hero-badge"><span className="pulse-dot"/> Yakında Geliyor</div>
          </div>
          <div className="fade-2" style={{ marginBottom:28 }}>
            <h1 style={{ fontSize:"clamp(40px,7vw,72px)", fontWeight:900, color:"white", lineHeight:1.05, letterSpacing:"-1.5px", marginBottom:6 }}>
              Siparişiniz,
            </h1>
            <h1 className="shimmer-text" style={{ fontSize:"clamp(40px,7vw,72px)", fontWeight:900, lineHeight:1.05, letterSpacing:"-1.5px", marginBottom:24 }}>
              Bizim İşimiz.
            </h1>
            <p style={{ fontSize:"clamp(15px,2.5vw,18px)", color:"rgba(255,255,255,0.8)", lineHeight:1.85, maxWidth:540, margin:"0 auto 8px" }}>
              Restoran ve kafeler için sipariş yönetimi artık çok daha kolay. Online siparişleri, masa siparişlerini ve paket servisleri —{" "}
              <strong style={{color:"white"}}>tek ekrandan, tek dokunuşla yönetin.</strong>
            </p>
            <p style={{ fontSize:"clamp(14px,2vw,16px)", color:"rgba(255,255,255,0.5)", lineHeight:1.8, maxWidth:500, margin:"12px auto 0" }}>
              Sipariş süreçlerinizi hızlandırır, insan hatalarını ortadan kaldırır ve müşterilerinizi memnun eder. Siz sadece işletmenizi büyütmeye odaklanın.
            </p>
          </div>
          <div className="hero-btns fade-3" style={{ display:"flex", justifyContent:"center", gap:12, flexWrap:"wrap" }}>
            <a href="#kayit" className="btn" style={{ textDecoration:"none", fontSize:16 }}>
              Erken Erişim Kaydı →
            </a>
            <a href="#oneriler" className="btn-outline" style={{ fontSize:16 }}>
              Öneri Gönder 💬
            </a>
          </div>
        </div>
      </div>

      {/* Ana içerik */}
      <div style={{ maxWidth:780, margin:"0 auto", padding:"0 24px 80px" }}>

        {/* Değer kartları */}
        <div className="fade-3 value-grid" style={{
          display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(170px,1fr))",
          gap:12, margin:"-36px 0 52px", position:"relative", zIndex:2
        }}>
          {farklar.map((f,i) => (
            <div key={i} className="value-card">
              <div style={{ fontSize:26, marginBottom:10 }}>{f.icon}</div>
              <div style={{ fontWeight:800, fontSize:14, marginBottom:6, color:"#1A2744" }}>{f.baslik}</div>
              <div style={{ fontSize:12, color:"#718096", lineHeight:1.6 }}>{f.aciklama}</div>
            </div>
          ))}
        </div>

        {/* Neden Siparişimiz */}
        <div className="fade-4" style={{ marginBottom:48 }}>
          <div className="section-label">Neden Siparişimiz?</div>
          <div className="card" style={{ padding:"32px" }}>
            <div className="compare-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:24 }}>
              {[
                { emoji:"😓", baslik:"Şu an nasıl?", renk:"#FC8181", isaret:"✗", items:["Kağıt fiş ve elle sipariş","Stok sayımı Excel'de","Garson çağrısı bağırarak","Patron mağazada olmak zorunda","Her sistem ayrı ücret"] },
                { emoji:"😊", baslik:"Siparişimiz ile?", renk:"#48BB78", isaret:"✓", items:["QR menüden anlık sipariş","Stok otomatik takip","Garson telefonuna bildirim","Patron her yerden izliyor","Hepsi tek pakette"] },
              ].map((col,i) => (
                <div key={i}>
                  <div style={{ fontWeight:900, fontSize:16, marginBottom:14, display:"flex", alignItems:"center", gap:8 }}>
                    <span>{col.emoji}</span> {col.baslik}
                  </div>
                  {col.items.map((item,j) => (
                    <div key={j} style={{
                      display:"flex", alignItems:"center", gap:8,
                      padding:"9px 0", borderBottom:"1px solid #F7F8FC",
                      fontSize:13, color: i===0 ? "#718096" : "#1A2744",
                      fontWeight: i===1 ? 700 : 400
                    }}>
                      <span style={{ color:col.renk, fontSize:16, flexShrink:0 }}>{col.isaret}</span>
                      {item}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Özellikler */}
        <div className="fade-5" style={{ marginBottom:48 }}>
          <div className="section-label">Neler Geliyor?</div>
          <p style={{ fontSize:14, color:"#718096", textAlign:"center", marginBottom:28 }}>
            Rakiplerin ayrı sattığı her şey tek pakette
          </p>
          <div className="features-grid" style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))", gap:16 }}>
            {ozellikler.map((o,i) => (
              <div key={i} className="card card-hover" style={{ padding:"24px" }}>
                <div className="feature-icon">{o.icon}</div>
                <div style={{ fontWeight:800, fontSize:15, marginBottom:8 }}>{o.baslik}</div>
                <div style={{ fontSize:13, color:"#718096", lineHeight:1.65 }}>{o.aciklama}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Alt mesaj banner */}
        <div className="fade-6" style={{
          background:"linear-gradient(135deg,#1A2744 0%,#243560 100%)",
          borderRadius:24, padding:"44px 32px", textAlign:"center",
          position:"relative", overflow:"hidden", marginBottom:48
        }}>
          <div style={{ position:"absolute", top:-60, right:-60, width:220, height:220, background:"radial-gradient(circle,rgba(255,107,0,0.2) 0%,transparent 70%)", pointerEvents:"none" }}/>
          <div style={{ fontSize:40, marginBottom:16 }}>🍽️</div>
          <p style={{ fontSize:"clamp(15px,2.5vw,19px)", color:"white", fontWeight:800, lineHeight:1.7, maxWidth:520, margin:"0 auto 12px" }}>
            Önce müşteriniz sipariş verir. Sonra mutfağınız harekete geçer. Sonra işletmeniz büyür.
          </p>
          <p style={{ fontSize:"clamp(14px,2vw,16px)", color:"rgba(255,255,255,0.6)", lineHeight:1.8, maxWidth:480, margin:"0 auto 20px" }}>
            Her adımda yanınızdayız — çünkü siparişiniz, bizim siparişimiz.
          </p>
          <p style={{ fontSize:20, fontWeight:900, color:"#FF6B00" }}>
            "Siparişiniz bizim siparişimiz." ✨
          </p>
        </div>

        {/* Email kayıt */}
        <div id="kayit" className="fade-6 card" style={{ padding:"32px", marginBottom:24 }}>
          <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:6 }}>
            <span style={{ fontSize:28 }}>🎯</span>
            <h2 style={{ fontSize:20, fontWeight:900 }}>Erken Erişime Kaydolun</h2>
          </div>
          <p style={{ fontSize:14, color:"#718096", marginBottom:20, lineHeight:1.6 }}>
            Hazır olduğumuzda ilk sizi haberdar edeceğiz.{" "}
            <strong style={{color:"#FF6B00"}}>İlk 100 işletmeye özel fiyat garantisi!</strong>
          </p>
          {emailDurum === "basarili" ? (
            <div className="success">🎉 Harika! Listeye eklendiniz. Hazır olunca sizi arayacağız!</div>
          ) : emailDurum === "hata" ? (
            <div className="error">Bir hata oluştu. Lütfen tekrar deneyin.</div>
          ) : (
            <>
              <div className="form-row" style={{ display:"flex", gap:10, marginBottom:emailHata?8:0 }}>
                <input className="email-input" type="email" placeholder="ornek@email.com"
                  value={email} onChange={e=>{ setEmail(e.target.value); setEmailHata(""); }}
                  onKeyDown={e=>e.key==="Enter"&&handleEmail()}/>
                <button className="btn" onClick={handleEmail} disabled={emailDurum==="yukleniyor"}>
                  {emailDurum==="yukleniyor" ? "⏳..." : "Kaydol →"}
                </button>
              </div>
              {emailHata && <p style={{ color:"#E53E3E", fontSize:13, paddingLeft:4 }}>{emailHata}</p>}
            </>
          )}
          <p style={{ fontSize:12, color:"#A0AEC0", marginTop:12 }}>🔒 Spam yok. İstediğiniz zaman çıkabilirsiniz.</p>
        </div>

        {/* Öneri formu */}
        <div id="oneriler" className="fade-7 card" style={{ padding:"32px", marginBottom:48 }}>
          <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:6 }}>
            <span style={{ fontSize:28 }}>💬</span>
            <h2 style={{ fontSize:20, fontWeight:900 }}>Bir Sipariş Sisteminde Ne Görmek İstersiniz?</h2>
          </div>
          <p style={{ fontSize:14, color:"#718096", marginBottom:20, lineHeight:1.6 }}>
            Restoran veya kafe sahibiyseniz bize anlatın —{" "}
            <strong style={{color:"#FF6B00"}}>sistemi sizin ihtiyaçlarınıza göre</strong> inşa ediyoruz. Her öneri değerli!
          </p>
          {oneriDurum === "basarili" ? (
            <div className="success">✨ Teşekkürler! Öneriniz bize ulaştı, dikkate alacağız.</div>
          ) : oneriDurum === "hata" ? (
            <div className="error">Bir hata oluştu. Lütfen tekrar deneyin.</div>
          ) : (
            <>
              <textarea className="textarea-input"
                placeholder="Örneğin: 'Garsonların siparişleri daha hızlı görmesini istiyorum' veya 'Stok takibi çok karmaşık olmasın, basit olsun'..."
                value={oneri} onChange={e=>setOneri(e.target.value)}/>
              <button className="btn" onClick={handleOneri}
                disabled={oneriDurum==="yukleniyor"||!oneri.trim()}
                style={{ marginTop:12, width:"100%" }}>
                {oneriDurum==="yukleniyor" ? "⏳ Gönderiliyor..." : "Öneriyi Gönder 🚀"}
              </button>
            </>
          )}
        </div>

        {/* Sosyal Medya & İletişim */}
        <div className="fade-8" style={{ marginBottom:40 }}>
          <div className="section-label">Bize Ulaşın</div>
          <div style={{ display:"flex", justifyContent:"center", gap:12, flexWrap:"wrap" }}>

            {/* WhatsApp */}
            <a
              href="https://wa.me/40791403434"
              target="_blank" rel="noopener noreferrer"
              style={{
                display:"inline-flex", alignItems:"center", gap:10,
                background:"#25D366", color:"white",
                borderRadius:14, padding:"14px 24px",
                fontWeight:800, fontSize:15, textDecoration:"none",
                boxShadow:"0 4px 16px rgba(37,211,102,0.3)",
                transition:"all .2s", fontFamily:"'Nunito',sans-serif"
              }}
              onMouseOver={e=>e.currentTarget.style.transform="translateY(-2px)"}
              onMouseOut={e=>e.currentTarget.style.transform="translateY(0)"}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.122 1.532 5.855L.054 23.447a.75.75 0 00.919.919l5.593-1.478A11.946 11.946 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.75a9.716 9.716 0 01-4.951-1.355l-.355-.212-3.664.968.984-3.595-.231-.371A9.718 9.718 0 012.25 12C2.25 6.615 6.615 2.25 12 2.25S21.75 6.615 21.75 12 17.385 21.75 12 21.75z"/>
              </svg>
              WhatsApp Destek
            </a>

            {/* Instagram */}
            <a
              href="https://instagram.com/siparisimizz"
              target="_blank" rel="noopener noreferrer"
              style={{
                display:"inline-flex", alignItems:"center", gap:10,
                background:"linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)",
                color:"white", borderRadius:14, padding:"14px 24px",
                fontWeight:800, fontSize:15, textDecoration:"none",
                boxShadow:"0 4px 16px rgba(220,39,67,0.3)",
                transition:"all .2s", fontFamily:"'Nunito',sans-serif"
              }}
              onMouseOver={e=>e.currentTarget.style.transform="translateY(-2px)"}
              onMouseOut={e=>e.currentTarget.style.transform="translateY(0)"}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
              </svg>
              Instagram
            </a>

{/* LinkedIn */}
            <a
              href="https://www.linkedin.com/in/siparişimiz-restoran-cafe-sipariş-sistemi-2b18973b6"
              target="_blank" rel="noopener noreferrer"
              style={{
                display: "inline-flex", alignItems: "center", gap: 10,
                background: "#0A66C2", color: "white",
                borderRadius: 14, padding: "14px 24px",
                fontWeight: 800, fontSize: 15, textDecoration: "none",
                boxShadow: "0 4px 16px rgba(10,102,194,0.3)",
                transition: "all .2s", fontFamily: "'Nunito',sans-serif"
              }}
              onMouseOver={e => e.currentTarget.style.transform = "translateY(-2px)"}
              onMouseOut={e => e.currentTarget.style.transform = "translateY(0)"}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
              LinkedIn
            </a>
          </div> {/* Sosyal medya butonlarını sarmalayan div'i kapatıyoruz */}

          {/* Email */}
          <p style={{ fontSize: 14, color: "#718096", textAlign: "center", marginTop: 20 }}>
            📧 Bize mail gönderin:{" "}
            <a href="mailto:info@siparisimiz.com" style={{ color: "#FF6B00", fontWeight: 700, textDecoration: "none" }}>
              info@siparisimiz.com
            </a>
          </p>
        </div> {/* Sosyal Medya & İletişim ana div'ini kapatıyoruz */}

        {/* Footer */}
        <div className="fade-8" style={{ textAlign: "center", borderTop: "1.5px solid #EDF2F7", paddingTop: 32 }}>
          <div style={{ display: "flex", justifyContent: "center", marginBottom: 14 }}>
            <Logo size={42} showText={false} />
          </div>
          <p style={{ fontSize: 13, color: "#A0AEC0", fontWeight: 700 }}>
            © 2025 Siparişimiz · siparisimiz.com
          </p>
          <p style={{ fontSize: 12, color: "#CBD5E0", marginTop: 6 }}>
            Türkiye'nin akıllı restoran yönetim sistemi
          </p>
        </div>

      </div> {/* İçerik kapsayıcısını (maxWidth:780) kapatıyoruz */}
    </div> /* Ana sarmalayıcıyı kapatıyoruz */
  );
}
